module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA3UlEQVQ4jc2SPUoDcRDFfxsWBCE5gcQTiEW6FFbBwqQUK2/gFbyHkDaWVimsvYWVhVjJWiVEXHbergwOslk7/0UyzQzz8ebNBzuXrGmaL+Dgn0TKzFQ3KVPkquukLfRMwqQzk95MujFpaNIm/FcmnYbt+sSkaeR6DXn1w2ANuPEJHAFLYAIUwCqauX4CjoHXqCE3U5fVJXAPfADnwLwVuwDGwO3vDir9ARgBC+ABuOsAPLYYbAH0fR/AofuAa+A5/IPIdT2L+DJiZC/vRdoZTWln9D8oUz4xqfseCPANJ+Rr8e0mzAsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/health/information_imei.png
// module id = G/JB
// module chunks = 4